const actions = {
    addPool: ({commit}, pool) => {
        commit('setPool', pool)
    },
}
export default actions